import type { StrapiSampleInformationRow } from '../../api/strapiCrm';
import type { StrapiManagedUserRow } from '../../api/strapiUsers';

/** Surveyor baru dari modal tab Sampel; di-flush bareng tombol footer Simpan work order. */
export type PendingSampleSurveyorDraft = {
  draftKey: string;
  sampleInformationPointDocumentId: string;
  user: StrapiManagedUserRow;
};

export function newDraftSurveyorKey(): string {
  return `srv-draft-${typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`}`;
}

function flattenPointIds(samples: StrapiSampleInformationRow[]): Set<string> {
  const ids = new Set<string>();
  for (const s of samples) {
    for (const p of s.sample_information_points ?? []) {
      const id = p.documentId?.trim();
      if (id) ids.add(id);
    }
  }
  return ids;
}

/** Sebelum flush surveyor baru: titik (`sample_information_point`) harus anak sampel WO (quotation) ini. */
export function validatePendingSurveyorDraftsForWorkOrderSave(
  samples: StrapiSampleInformationRow[],
  drafts: PendingSampleSurveyorDraft[],
): string | null {
  if (drafts.length === 0) return null;
  const pointIds = flattenPointIds(samples);
  for (let i = 0; i < drafts.length; i += 1) {
    const d = drafts[i];
    const pid = d.sampleInformationPointDocumentId?.trim();
    if (!pid || !pointIds.has(pid)) {
      return (
        'Ada surveyor draf yang tidak terhubung ke titik sampel quotation work order ini. ' +
        'Muat ulang halaman atau tambahkan ulang surveyor di tab Sampel.'
      );
    }
    const hasUserRef =
      Boolean(d.user.documentId?.trim()) || (d.user.numericId != null && Number.isFinite(d.user.numericId));
    if (!hasUserRef) {
      return `User surveyor pada draf nomor ${i + 1} tidak punya id yang valid untuk Strapi. Pilih ulang user di tab Sampel.`;
    }
  }
  return null;
}
